/**
 * QualGear buy-box mini sticky bar (mobile safe-area bottom bar).
 *
 * The buy box itself is sticky via CSS (`position: sticky`, desktop only —
 * see qg-product.css). This script only manages the small mobile bar that
 * appears once the real Add to cart button has scrolled out of view. The
 * mini bar's button does not duplicate the cart-submission logic — it
 * scrolls the real buy box back into view (same pattern the vendor's own
 * sticky-cta uses: anchor-to-section, never a second cart form), which
 * avoids a fragile duplicate-submit integration with the AJAX cart.
 */
(function () {
  if (window.qgProductBuyboxInit) return;
  window.qgProductBuyboxInit = true;

  var bars = document.querySelectorAll('[data-qg-mini-atc]');
  if (!bars.length) return;

  bars.forEach(function (bar) {
    var watchSelector = bar.getAttribute('data-qg-mini-atc-watch');
    var watchTarget = watchSelector ? document.querySelector(watchSelector) : null;
    if (!watchTarget || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('qg-product-buybox__mini-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(watchTarget);

    var scrollButton = bar.querySelector('[data-qg-mini-atc-scroll]');
    if (scrollButton) {
      scrollButton.addEventListener('click', function () {
        /* RS1010-AXE-D05 (FIX-1): no smooth scroll under prefers-reduced-motion. */
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        watchTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        /* Same-page jump, so focus follows it (WCAG 2.4.3): the watch target is
           the real Add to cart button. preventScroll keeps the centred position. */
        if (typeof watchTarget.focus === 'function') watchTarget.focus({ preventScroll: true });
      });
    }
  });
})();
